import { loadEpisodeCatalog } from '@/_pure/episodeCatalog';
import catalog from '@/adapters/core/_data/episodes/_@shared/catalog.json' with { type: 'json' };
import { parseCoreEpisode } from '@/adapters/core/_pure/episode';

// Register each authored episode document here and list its id in the catalog.
const documents = new Map<string, unknown>([]);

export const coreEpisodes = loadEpisodeCatalog('Core', catalog, documents, parseCoreEpisode);

export function resolveCoreEpisode(handle: string, sceneIndex = 0) {
    const episode = coreEpisodes.find((ep) => ep.handle === handle);
    const scene = episode?.scenes[sceneIndex];
    if (!episode || !scene) throw new Error(`Core Episode '${handle}' or its scene is unavailable.`);
    return { episode, scene };
}
